import {useMap} from "react-leaflet";
import {useEffect} from "react";


export default function FlyToPoint({point, zoom = 16}) {
    const map = useMap();

    useEffect(() => {
        if (!point) return;
        map.flyTo(
            [point?.latitude, point?.longitude],
            zoom,
            {
                duration: 2
            }
        );
    }, [point]);

    return null;
}
